<template>
  <v-card flat class="sources">
  <v-alert
      type="info"
      border="left"
      colored-border
      class="sourcealert"
      >
      <div>ICT PLUS pulls data from existing systems, if something doesn't seem quite right with the data you're seeing please let us know.</div>
      <div  class="pt-2">
        <a href="javascript:void(0);" id="vts_feedback">LEAVE FEEDBACK</a>
        </div>
    </v-alert>
    <v-subheader class="subheader mt-5">Network Usage
    </v-subheader>
  <v-card>
  <v-simple-table>

    <template v-slot:default>
      <thead>
        <tr class="headings">
          <th width="20%" class="text-left">Data Source</th>
          <th width="50%" class="text-left">Purpose</th>
           <th width="25%" class="text-left">ICT PLUS Update Interval</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in networkUsage" :key="item.source">
          <td class="pt-5 pb-5 pr-5">{{item.source}}</td>
          <td class="pt-5 pb-5 pr-5">{{item.purpose}}</td>
          <td class="pt-5 pb-5 pr-5">{{item.interval}}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
    </v-card>

    <v-subheader class="subheader mt-5">Managed Devices
    </v-subheader>
  <v-card>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr class="headings">
          <th width="20%" class="text-left">Data Source</th>
          <th width="50%" class="text-left">Purpose</th>
          <th width="25%" class="text-left">ICT PLUS Update Interval</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in planningDashboard" :key="item.source">
          <td class="pt-5 pb-5 pr-5">{{item.source}}</td>
          <td class="pt-5 pb-5 pr-5">{{item.purpose}}</td>
          <td class="pt-5 pb-5 pr-5">{{item.interval}}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
    </v-card>
  </v-card>

</template>

<script>
  export default {
    name: 'SOURCES',
    data(){
      return {
      networkUsage:[
      {
        source:"BUD",
        purpose:"Provides insight regarding WAN Utilisation and I@E Utilisation within a school, as well as the bandwidth cap for each",
        interval:"This data comes through to ICT PLUS in real-time."
      }
    ],
    planningDashboard:[
      {
        source:"Active Directory (AD)",
        purpose:"Provides location data manually populated in UDM for Microsoft managed devices.",
        interval:"Automatically reloaded at 1AM every morning."
      },
      {
        source:"Jamf",
        purpose:"Provide Apple device data, for managed devices.",
        interval:"Automatically, at midnight and noon every day."
      },
      {
        source:"BUD",
        purpose:"Provides site data from the CESE Master Dataset, including school code, address, number of FTE student enrolments, etc.",
        interval:"Twice annually. School site data was last updated at 11am on June 21st 2021."
      },
      {
        source:"Chrome Database",
        purpose:"Provides Chrome Book device data, for managed devices.",
        interval:"Automatically, every three hours from midnight."
      },
      {
        source:"Configuration Manager (CM)",
        purpose:"CM provides Microsoft Windows data, for managed devices.",
        interval:"Automatically, every four hours from midnight."
      },
      {
        source:"DoE Software Catalogue",
        purpose:"Model Release Date data is manually sourced each year via eT4L; or if not available, from the manufacturer’s website. It is then manually manipulated so that it can be associated to each device uploaded to ICT PLUS.",
        interval:"Twice annually. This data was last updated at 5pm on December 7th 2020."
      }
    ]
    }
    }
  };

</script>
<style lang="scss" scoped>
::v-deep .available .theme--light.v-icon{
  color:#00A908 !important;
  font-size:20px;
}
::v-deep .unavailable .theme--light.v-icon{
  color:#B81237 !important;
  font-size:20px;
}
.headings th{
  font-family: Arial;
font-style: normal;
font-weight: bold;
font-size: 14px !important;
line-height: 17px;
color: #121212 !important;
padding:20px;
}
.v-data-table tbody tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper){
      background: transparent !important;
  }
.subheader{
font-family: Arial;
font-style: normal;
font-weight: bold;
font-size: 24px;
line-height: 30px;
color: #041E42;
padding:24px 0 40px 0;
}
.sourcealert{

  font-family: Arial;
  font-weight: bold;
  background-color:#E0E9FF;
  font-size: 16px;
  line-height: 24px;
  color: #121212;
  ::v-deep .v-alert__border--left ,
  ::v-deep .v-alert__icon {
    color:#2E5299 !important;
    border-color:#2E5299 !important;
  }
}
.sourcealert a{
    text-decoration:none;
    color: #2E5299;
}
.sources{
  padding:0;
  background: #FFFFFF;

}
</style>
